export const featureFlagsNewlyEnabled: string[] = [];
export const featureFlagsState: Record<string, boolean> = {};

const generateLocalStorageStringFlag = (name: string) => {
    const ff = {
        name,
        get value() {
            return localStorage.getItem(`ff/${name}`) || '';
        },
        set value(val: string) {
            if (val) {
                localStorage.setItem(`ff/${name}`, val);
            } else {
                localStorage.removeItem(`ff/${name}`);
            }
        },
        clear() {
            localStorage.removeItem(`ff/${name}`);
        },
    };

    const urlParams = new URLSearchParams(window.location.search);
    const urlValue = urlParams.get(name);
    if (urlValue) {
        ff.value = urlValue;
    }

    // @ts-ignore
    window[`FF_${name}`] = ff;

    return ff;
};

const generateLocalStorageFeatureFlag = (name: string) => {
    const ff = {
        name,
        get on() {
            const isEnabled = localStorage.getItem(`ff/${name}`) === 'true';
            featureFlagsState[name] = isEnabled;

            return isEnabled;
        },
        set on(value: boolean) {
            localStorage.setItem(`ff/${name}`, value.toString());
        },
        get off() {
            return !this.on;
        },
        toggle() {
            this.on = !this.on;
            return this.on;
        },
    };

    if (window.location.search.includes(`${name}=on`)) {
        featureFlagsNewlyEnabled.push(name);
        ff.on = true;
    }
    if (window.location.search.includes(`${name}=off`)) {
        ff.on = false;
    }

    // @ts-ignore
    window[`FF_${name}`] = ff;

    return ff;
};

// TODO: will remove once their theme is customized
export const FF_SHYROHEALTH_CUSTOM_THEME = generateLocalStorageFeatureFlag(
    'SHYROHEALTH_CUSTOM_THEME',
);
export const FF_CHECKPOINT_CUSTOM_THEME = generateLocalStorageFeatureFlag(
    'CHECKPOINT_CUSTOM_THEME',
);
export const FF_WHITE_LABEL_EXAMPLE_THEME = generateLocalStorageFeatureFlag(
    'WHITE_LABEL_EXAMPLE_THEME',
);

export const FF_FEATURE_LOCKING =
    generateLocalStorageFeatureFlag('FEATURE_LOCKING');
export const FF_UNIFY_DOCUMENT_API =
    generateLocalStorageFeatureFlag('UNIFY_DOCUMENT_API');
export const FF_BETA_CHANNEL_CUSTOMER =
    generateLocalStorageFeatureFlag('BETA_CUSTOMER');

export const FF_AR_STREAMING = generateLocalStorageFeatureFlag('AR_STREAMING');

export const FF_GLOBAL_TEMPLATES_EDITING = generateLocalStorageFeatureFlag(
    'GLOBAL_TEMPLATES_EDITING',
);

export const FF_BACKEND_ENV = generateLocalStorageStringFlag('BACKEND_ENV');
